// Builds JSON-LD for a Skills Hub category page (/skills-hub/[categoryId]).
//
// The /skills-hub landing models each tile as a CollectionPage (see
// lib/skillsHubSchema.ts). The real Course entities live here: one Course per
// parent class in the category, wrapped in an ItemList. Built from the same
// `classes` array the page renders so schema can't drift from the page.

import { Category, LiveClassParent } from "../interfaces";

const SITE_URL = "https://sols.foundation";
const PROVIDER_NAME = "SOLS Foundation";

const PROVIDER = {
  "@type": "EducationalOrganization",
  name: PROVIDER_NAME,
  url: SITE_URL,
  sameAs: SITE_URL,
};

const stripHtml = (html: string | undefined): string => {
  if (!html) return "";
  return html
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

export const buildCategorySchema = (
  category: Category | null | undefined,
  classes: LiveClassParent[] | undefined
) => {
  const categoryId = category?.lcCategoryId;
  const list = (classes || []).filter((c) => c && c.lpId && c.lpTitle);

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: category?.lcCategoryName
      ? `${category.lcCategoryName}: Free Online Courses`
      : "Free Online Courses",
    url: categoryId ? `${SITE_URL}/skills-hub/${categoryId}` : `${SITE_URL}/skills-hub`,
    numberOfItems: list.length,
    itemListElement: list.map((cls, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Course",
        name: cls.lpTitle,
        description:
          stripHtml(cls.lpDesc) || `Free online course offered by ${PROVIDER_NAME}.`,
        url: `${SITE_URL}/skills-hub/${categoryId}/${cls.lpId}`,
        ...(cls.lpImage ? { image: cls.lpImage } : {}),
        provider: PROVIDER,
        isAccessibleForFree: true,
        inLanguage: ["en", "ms", "id", "zh-CN"],
        educationalCredentialAwarded: "Certificate of Completion",
        offers: {
          "@type": "Offer",
          price: 0,
          priceCurrency: "MYR",
          availability: "https://schema.org/InStock",
          category: "Free",
        },
      },
    })),
  };
};
